import { ExclamationCircleFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'

type Props = {
  visible?: boolean
  entity: 'учащийся' | 'сотрудник' | 'родитель'
}

const MissingFranchiseWarning = ({ visible = false, entity }: Props) => {
  if (!visible) return null

  return (
    <Tooltip
      title={`Данный ${entity} не привязан ни к какой франшизе/филиалу. Он не сможет зайти на платформу, пока вы его не привяжете к какой-либо франшизе/филиалу`}
    >
      <span
        aria-label="Не выбран филиал"
        onClick={(event) => event.stopPropagation()}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          color: 'var(--color-status-danger-text)',
          cursor: 'help',
          flexShrink: 0,
        }}
      >
        <ExclamationCircleFilled
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      </span>
    </Tooltip>
  )
}

export default MissingFranchiseWarning
